module.exports = __webpack_public_path__ + "static/media/notifications-active.1500c1fb.svg";